var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompensationTableFirstRecord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#D9F4F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8002 12.8004C16.8002 13.0052 16.7218 13.21 16.5658 13.366L12.5658 17.366C12.253 17.6788 11.7474 17.6788 11.4346 17.366L7.43455 13.366C7.12175 13.0532 7.12175 12.5476 7.43455 12.2348C7.74735 11.922 8.25295 11.922 8.56575 12.2348L12.0002 15.6692L15.4346 12.2348C15.7474 11.922 16.253 11.922 16.5658 12.2348C16.7218 12.3908 16.8002 12.5956 16.8002 12.8004Z",
    fill: "#0098A5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8002 8.00009C16.8002 8.20489 16.7218 8.40969 16.5658 8.56569L12.5658 12.5657C12.253 12.8785 11.7474 12.8785 11.4346 12.5657L7.43455 8.56569C7.12175 8.25289 7.12175 7.74729 7.43455 7.43449C7.74735 7.12169 8.25295 7.12169 8.56575 7.43449L12.0002 10.8689L15.4346 7.43449C15.7474 7.12169 16.253 7.12169 16.5658 7.43449C16.7218 7.59049 16.8002 7.79529 16.8002 8.00009Z",
    fill: "#0098A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompensationTableFirstRecord);
export default __webpack_public_path__ + "609dea3858a7aeddba0a87283f90b5fa.svg";
export { ForwardRef as ReactComponent };